import React from 'react';
import { UserAvatar } from '../../../UserAvatar';
import { useItemHandleFragment$data } from '../../hooks/__generated__/useItemHandleFragment.graphql';

export const ItemAvatar = ({ item }: { item: useItemHandleFragment$data }) => {
  if (item.__typename !== 'Member') {
    return null;
  }

  return <UserAvatar member={item} />;
};
